export default Object.freeze({
  Entity: 'entity',
  ProcessInstance: 'process-instance',
  List: 'list',
  Chat: 'chat',
  All: 'all',
  Report: 'report',
  DocumentExport: 'document-export',
  BulkRequest: 'bulk-request',
  ConfigurationEntity: 'configuration-entity',
});
